import { useSelector, useDispatch } from 'react-redux'
import { useRoutesContext } from '../components/RoutesContext'
import { navigated } from '../state/app/actions'
import { isGuestSelector } from '../state/user/selectors'

export const useProtectedRoute = () => {
  const isGuest = useSelector(isGuestSelector)
  const dispatch = useDispatch()
  const { toLogin } = useRoutesContext()
  if (isGuest) {
    dispatch(navigated(toLogin()))
  }
}
